/**************************************************
 * Nombre:       Tarjeta_Preguntas_Test
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Preguntas_Test = ({item, index, click}) => {


    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 1, cursor: 'pointer'}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 600, fontSize: 14}}>{item.pregunta}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Typography sx={{fontSize: 16}}>{item.respuesta}
                    <span style={{paddingLeft: 5, fontWeight: 600, fontSize: 14}}>{item.punto ? '(Correcto)' : '(Incorrecto)'}</span>
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Preguntas_Test